let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hs3S4")).then(() => parcelRequire('epI6x'));